import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import defaultData from '../public/default.json'; // Pfad zu default.json anpassen
import deepCloneBlock from './utils/deepCloneBlock';
import clipboardHelper from './utils/clipboardHelper';
import { getXmlValueByPath } from './utils/getXmlValueByPath';

export default createStore({
  state: {
    sharedData: null,
    exampleMail: '/jsonFiles/manual.json',
    emailTitle: 'Quick Start Guide',
    tabData: [],
    view: 'Edit',
    add: null,
    positionBoiler: null,
    parentBoiler: null,
    emailData: null,
    previewData: null,
    placeholdersEnabled: false,
    customerData: null,
    fullCustomerData: null,
    viewport: "computer",
    activeTab: 'Global',
    cssClasses: [],
    mediaQueries: '',
    colorMode: 'light',
    //theme: 'default', // Standardtheme default or customer1
    theme: 'default',
    xmlFile: null,
    defaultXml: null,
    xPathPlaceholders: [{ placeholder: '', xpath: '' }],
    locale: 'en',
    copyClipboard: null,
    copyClipboardHelper: null,
    envVars: {},
    currentFolder: 0,
    theme: { primaryColor: '#f2f2f2', secondaryColor: '#15779b', textColor: '#005e73'},
    path: [],
    user: null,
    containerEditMode: false
  },
  mutations: {
    setSharedData(state, object) {
      state.sharedData = object;
    },
    resetSharedData(state) {
      state.sharedData = null;
    },
    setExampleMail(state, data) {
      state.exampleMail = data;
    },
    setView(state, view) {
      state.view = view;
    },
    setActiveTab(state, tab) {
      state.activeTab = tab;
    },
    setAdd(state, item) {
      state.add = item;
    },
    setPositionBoiler(state, item) {
      state.positionBoiler = item;
    },
    setViewport(state, item) {
      state.viewport = item;
    },
    setParentBoiler(state, item) {
      state.parentBoiler = item;
    },
    resetAdd(state) {
      state.add = null;
    },
    setEmailData(state, data) {
      console.log(data)
      state.emailData = data;
      if (!data.title) state.emailData.title = state.emailTitle;
      //const id = `ID-${Math.floor(Math.random() * 900000000000) + 1000000000000}`
      if (!state.emailData.id) state.emailData.id = id;
      state.emailData.root.data.fontFamily = state.envVars.font || state.emailData.root.data.fontFamily;
      state.emailData.root.data.padding= state.envVars.padding  || state.emailData.root.data.padding;
      const title = state.emailTitle;
      const exists = state.tabData.some(item => item.id === data?.id || null);
      if(!exists){
        state.tabData.forEach((element) => {
          element.active = false;
        });
        const dataForTab = {title, ...data, active: true}
        if(state.tabData.length < 5) state.tabData.push(dataForTab);
      }

    },
    setSingleTab(state) {
      const title = state.emailTitle;
      const data = state.emailData;
      if(state.tabData.length > 1) state.tabData= state.tabData.map(obj => obj.id == state.emailData.id? {title, ...data}  : obj);
    },
    setEmailTitle(state, title) {
      state.emailTitle = title;
      state.emailData.title = title;
      state.tabData.find(tab => tab.id == state.emailData.id).title = title 
    },
    resetEmailTitle(state) {
      state.emailTitle = 'newTemplate';
    },
    replacePlaceholderState(state, {enabled}) {
      state.placeholdersEnabled = enabled;
      console.log(state.containerEditMode)
      state.containerEditMode = true;
      console.log(state.containerEditMode)
    },
    addBlock(state, { id, creationDate, block, position, parentId, parentType, targetId, placeholderIndex }) {
      state.emailData[id] = {creationDate, ...block};
      if(state.emailData[id].type !== 'Ruleset'){
        state.emailData[id].data.style.padding =  state.emailData.root.data.padding? JSON.parse(JSON.stringify(state.emailData.root.data.padding)) : {top: 2, right: 24, bottom: 2, left: 24}
        state.emailData[id].data.props.activeSections = ['main'] 
      }
      if (parentType === 'root') {
        const targetIndex = state.emailData.root.data.childrenIds.indexOf(targetId);
        if (position === 'top' && targetIndex > -1) {
          state.emailData.root.data.childrenIds.splice(targetIndex, 0, id);
        } else if (position === 'bottom' && targetIndex > -1) {
          state.emailData.root.data.childrenIds.splice(targetIndex + 1, 0, id);
        } else {
          state.emailData.root.data.childrenIds.push(id);
        }
      } else if (parentType === 'ColumnsContainer') {
        const columnIndex = placeholderIndex !== null ? placeholderIndex : state.emailData[parentId]
          .data.props.columns
          .findIndex(column => column.childrenIds && column.childrenIds.includes(targetId));
      
        if (columnIndex !== -1) {
          const column = state.emailData[parentId].data.props.columns[columnIndex];
          if (!column.childrenIds) {
            column.childrenIds = [];
          }
          const targetIndex = column.childrenIds.indexOf(targetId);
          if (position === 'top' && targetIndex > -1) {
            column.childrenIds.splice(targetIndex, 0, id);
          } else if (position === 'bottom' && targetIndex > -1) {
            column.childrenIds.splice(targetIndex + 1, 0, id);
          } else {
            column.childrenIds.push(id);
          }
        } 
      } else {
        const targetIndex = state.emailData[parentId].data.props.childrenIds.indexOf(targetId);
        console.log(targetId)
        if (position === 'top' && targetIndex > -1) {
          state.emailData[parentId].data.props.childrenIds.splice(targetIndex, 0, id);
        } else if (position === 'bottom' && targetIndex > -1) {
          state.emailData[parentId].data.props.childrenIds.splice(targetIndex + 1, 0, id);
          console.log('test')
        } else {
          state.emailData[parentId].data.props.childrenIds.push(id);
          
        }
      }
    },
    removeBlock(state, { parentId, parentType, blockId}) {
      if (parentType === 'root') {
        state.emailData.root.data.childrenIds = state.emailData.root.data.childrenIds.filter(id => id !== blockId);
        
      } else if (parentType === 'ColumnsContainer') {
        state.emailData[parentId].data.props.columns.forEach(column => {
          column.childrenIds = column.childrenIds.filter(id => id !== blockId);
        });
      } else {
        state.emailData[parentId].data.props.childrenIds = state.emailData[parentId].data.props.childrenIds.filter(id => id !== blockId);
      }
      let children = []
      const deleteChildrenBlocks = (id) => {
        if (state.emailData[id].data.props.childrenIds){
          state.emailData[id].data.props.childrenIds.forEach((child) => {
          children.push(child)
          deleteChildrenBlocks(child)}
          )
        }
      }
      deleteChildrenBlocks(blockId)
      console.log(children)
      if (children) {children.forEach ((child) => delete state.emailData[child])} 
      delete state.emailData[blockId];
    },
    addMultipleBlocks(state, { blocks, position, parentId, parentType, targetId, placeholderIndex }) {
      // Fügt alle Blöcke zum emailData-Objekt hinzu
      Object.keys(blocks).forEach(blockId => {
        state.emailData[blockId] = blocks[blockId];
      });
  
      // Sammle alle IDs der Kinder von ColumnsContainer und Container Blöcken
      const childBlockIds = new Set();
      Object.keys(blocks).forEach(blockId => {
        const block = blocks[blockId];
        if (block.type === 'ColumnsContainer' ) {
          block.data.props.columns.forEach(column => {
            column.childrenIds.forEach(childId => {
              childBlockIds.add(childId);
            });
          });
          if (block.data.props.childrenIds) {
            block.data.props.childrenIds.forEach(childId => {
              childBlockIds.add(childId);
            });
          } 
        }
        if (block.type === 'Container') {
          childBlockIds.add(block.data.props.childrenIds)
         if (block.data.props.childrenIds) {
            block.data.props.childrenIds.forEach(childId => {
              childBlockIds.add(childId);
            });
          } 
        }
      });
  
      // Filtere die Root-Blöcke, um nur die Blöcke zu bekommen, die keine Kinder anderer Blöcke sind
      const rootBlockIds = Object.keys(blocks).filter(blockId => !childBlockIds.has(blockId));
  
      // Fügt die Root-Block-IDs in die entsprechende Elternkomponente ein
      if (parentType === 'root') {
        const targetIndex = state.emailData.root.data.childrenIds.indexOf(targetId);
        if (position === 'top' && targetIndex > -1) {
          state.emailData.root.data.childrenIds.splice(targetIndex, 0, ...rootBlockIds);
        } else if (position === 'bottom' && targetIndex > -1) {
          state.emailData.root.data.childrenIds.splice(targetIndex + 1, 0, ...rootBlockIds);
        } else {
          state.emailData.root.data.childrenIds.push(...rootBlockIds);
        }
      } else if (parentType === 'ColumnsContainer') {
        const columnIndex = placeholderIndex !== null ? placeholderIndex : state.emailData[parentId]
          .data.props.columns
          .findIndex(column => column.childrenIds && column.childrenIds.includes(targetId));
  
        if (columnIndex !== -1) {
          const column = state.emailData[parentId].data.props.columns[columnIndex];
          if (!column.childrenIds) {
            column.childrenIds = [];
          }
          const targetIndex = column.childrenIds.indexOf(targetId);
          if (position === 'top' && targetIndex > -1) {
            column.childrenIds.splice(targetIndex, 0, ...rootBlockIds);
          } else if (position === 'bottom' && targetIndex > -1) {
            column.childrenIds.splice(targetIndex + 1, 0, ...rootBlockIds);
          } else {
            column.childrenIds.push(...rootBlockIds);
          }
        }
      } else {
        if (!state.emailData[parentId].data.props.childrenIds) {
          state.emailData[parentId].data.props.childrenIds = [];
        }
        const targetIndex = state.emailData[parentId].data.props.childrenIds.indexOf(targetId);
        if (position === 'top' && targetIndex > -1) {
          state.emailData[parentId].data.props.childrenIds.splice(targetIndex, 0, ...rootBlockIds);
        } else if (position === 'bottom' && targetIndex > -1) {
          state.emailData[parentId].data.props.childrenIds.splice(targetIndex + 1, 0, ...rootBlockIds);
        } else {
          state.emailData[parentId].data.props.childrenIds.push(...rootBlockIds);
        }
      }
    },
    MOVE_BLOCK(state, { id, direction }) {
      const parentId = 'root';  // Assuming 'root' is always the parent for top-level blocks
      const parentData = state.emailData[parentId].data;
  
      const index = parentData.childrenIds.indexOf(id);
      if (index === -1) return;
  
      let newIndex;
      if (direction === 'up' && index > 0) {
        newIndex = index - 1;
      } else if (direction === 'down' && index < parentData.childrenIds.length - 1) {
        newIndex = index + 1;
      } else {
        return; // can't move up if it's already at the top, or down if it's already at the bottom
      }
  
      parentData.childrenIds.splice(index, 1);
      parentData.childrenIds.splice(newIndex, 0, id);
    },
    moveAbsoluteBlock (state, { id, direction }) {
    switch (direction){
      case 'up':
        state.emailData[id].data.style.direction.top = state.emailData[id].data.style.direction.top - 10
        if (state.emailData[id].data.style.direction.top < 0) state.emailData[id].data.style.direction.top = 0
        break;
      case 'down':
        state.emailData[id].data.style.direction.top = state.emailData[id].data.style.direction.top + 10
        if (state.emailData[id].data.style.direction.top < 0) state.emailData[id].data.style.direction.top = 0
        break;
      case 'left':
        state.emailData[id].data.style.direction.left = state.emailData[id].data.style.direction.left - 10
        if (state.emailData[id].data.style.direction.left < 0) state.emailData[id].data.style.direction.left = 0
        break;
      case 'right':
        state.emailData[id].data.style.direction.left = state.emailData[id].data.style.direction.left + 10
        if (state.emailData[id].data.style.direction.left < 0) state.emailData[id].data.style.direction.left = 0
        break;
    }},
    setMediaQueries(state, mediaQueries) {
      state.mediaQueries = mediaQueries;
    },
    clearMediaQueries(state) {
      state.mediaQueries = ''; // Zum Zurücksetzen der Media Queries
    },
    setColorMode(state, value) {
      state.colorMode = value;
    },
    ADD_CLASS(state, className) {
      if (!state.cssClasses.includes(className)) {
        state.cssClasses.push(className);
      }
    },
    
    REMOVE_CLASS(state, className) {
      state.cssClasses = state.cssClasses.filter(cls => cls !== className);
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
    setXmlFile(state, file) {
      state.xmlFile = file;
    },
    insertXml(state, file) {
      state.emailData.xml = file;
    },
    setDefaultXml(state, file) { // action to set default #
      state.defaultXml = file;
    }, 
    setXPathPlaceholders(state, placeholderMapping) {
      state.xPathPlaceholders = placeholderMapping;
      console.log(state.xPathPlaceholders)
    },
    SET_LOCALE(state, locale) {
      state.locale = locale;
      console.log(state.locale)
    },
    setCopyClipboard(state, data) {
      state.copyClipboard = data;
      console.log(data)
      let childrenBlocks = []
      if(data.data.props.childrenIds) childrenBlocks = clipboardHelper(data.data.props.childrenIds) 
      if(data.data.props.columns){
        data.data.props.columns.forEach(column => {
          if (column.childrenIds && column.childrenIds.length > 0) {
            const array = clipboardHelper(column.childrenIds)
            array.forEach(block => {
              childrenBlocks.push(block)})
          }
        })
      }
      console.log(childrenBlocks)
      const originId = state.emailData.id
      state.copyClipboardHelper = {originId, blocks: childrenBlocks}
    },
    addSingleBlock(state, block){
      const id = block.id;
      delete block.id;
      state.emailData[id]= block
    },
    setTabData(state, data) { 
      state.tabData = data;
      state.xmlFile = data.xml ? data.xml : state.defaultXml // default xml or specific xml
    },
    removeTabById(state, id) {
      if (state.tabData.length != 1 && id !== state.emailData.id) {
        state.tabData = state.tabData.filter(item => item.id !== id);
      } else if (id == state.emailData.id && state.tabData.length > 1) {
        state.tabData = state.tabData.filter(item => item.id !== id);
         const newmailData = JSON.parse(JSON.stringify(state.tabData[0]))
         delete newmailData.active
         state.emailTitle = newmailData.title;
         delete newmailData.title;
         state.emailData = newmailData;
      } else if (state.tabData.length = 1) {
        state.tabData = state.tabData
      }
    },
    setEnvVars(state, vars) {
      state.envVars = vars;
    },
    setFolder(state, folderId){
      state.currentFolder = folderId
    },
    updatePath(state, newPath) {
      state.path = newPath;
      console.log(state.path)
    },
    updateUser(state, name){
      state.user = name
    },
    setPreviewData(state, data){
      state.previewData = data
    }
  },
  actions: {
    /* async loadEmailData({ commit, dispatch, state }) {
      try {
        const response = await axios.get(state.exampleMail);
        commit('setSingleTab')
        commit('setEmailData', response.data, id);
        //dispatch('loadEnvVar');
        dispatch('loadXmlData');
      } catch (error) {
        console.error('Failed to load email data:', error);
      }
    }, */
    async loadEmailData({ commit, dispatch, state }) {
      try {
        const emailResponse = await axios.get(state.exampleMail);
        let id;
        if (state.exampleMail != '/jsonFiles/manual.json'){
        const addEmailResponse = await axios.post('https://html-creator.demo.cartago.com/api/add-email', {
          emailId: 0,
          folderId: state.currentFolder
        });
          id = addEmailResponse.data.emailId
        } else {
          id = "Guide"
        }
        const responseData = emailResponse.data
        const data = {id, ...responseData}
        commit('setSingleTab');
        commit('setEmailData', data);
        dispatch('loadXmlData');
      } catch (error) {
        console.error('Failed to load email data:', error);
      }
    },    
    async loadXmlData({ commit }) {
      try {
        const response = await axios.get('/customerData/exampleData.xml', {
          headers: {
            'Content-Type': 'application/xml' // Gebe den erwarteten Inhaltstyp an
          },
          responseType: 'text' // Sage axios, dass die Antwort als Text behandelt werden soll
        });
        commit('setXmlFile', response.data);
        commit ('setDefaultXml', response.data) //hier wird eine default Xml festgelgt die als Fallback dient #
      } catch (error) {
        console.error('Failed to load xml data:', error);
      }
    },
    async loadEnvVars({ commit }) {
      try {
        const response = await fetch('/api/env');
        console.log('HTTP-Status:', response.status); // Prüfe den Statuscode
        const text = await response.text(); // Prüfe die Antwort als Text
        const vars = JSON.parse(text); // JSON parsen
        commit('setEnvVars', vars); // Speichere die Variablen im State
        commit('setTheme', vars.theme); //Theme setzen
      } catch (error) {
        console.error('Failed to load environment variables:', error);
      }
    },
    updateSharedData({ commit }, {id, data}) {
      commit('setSharedData', {id, ...data});
      commit('setActiveTab', 'Inspect');
    },
    resetSharedData({ commit }) {
      commit('resetSharedData');
    },
    updateEmailTitle({ commit }, data) {
      commit('setEmailTitle', data);
    },
    updateExampleMail({ commit, dispatch }, data) {
      commit('setExampleMail', data);
      return dispatch('loadEmailData');
    },
    updateView({ commit }, view) {
      commit('setView', view);
    },
    updateActiveTab({ commit }, tab) {
      commit('setActiveTab', tab);
      commit('resetSharedData');
    },
    updateAddState({ commit }, item) {
      commit('setAdd', item);
    },
    updateEmailData({ commit }, data) {
      commit('setSingleTab')
      commit('setEmailData', data);
    },
    updatePositionBoiler({ commit }, item) {
      commit('setPositionBoiler', item);
    },
    updateParentBoiler({ commit }, item) {
      commit('setParentBoiler', item);
    },
    updateViewport({ commit }, item) {
      commit('setViewport', item);
    },
    resetAddState({ commit }) {
      commit('resetAdd');
    },
    resetEmailTitle({ commit }) {
      commit('resetEmailTitle');
    },
    addNewBlockOld({state, commit }, { type, position, parentId, parentType, targetId, placeholderIndex }) {
      const id = `block-${Math.floor(Math.random() * 900000000000) + 1000000000000}`;
      const name = `${type}${id}`;
      const creationDate = new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });
      const block = defaultData[type] ? JSON.parse(JSON.stringify(defaultData[type])) : null;
      if (type == 'Image') block.data.props.url = state.envVars.imageUrl || block.data.props.url ;
      block.data.props.name= name
      if (block) {
        commit('addBlock', { id, creationDate, block, position, parentId, parentType, targetId, placeholderIndex });
        commit('setAdd', null);
        commit('setSharedData', { id, creationDate, ...block });
      } else {
        console.error(`Block type "${type}" not found in default data.`);
      }
    },

    async addNewBlock({ state, commit }, { type, position, parentId, parentType, targetId, placeholderIndex }) {
      try {
        // Block-Daten aus den Default-Daten generieren
        const block = defaultData[type] ? JSON.parse(JSON.stringify(defaultData[type])) : null;
        if (!block) {
          console.error(`Block type "${type}" not found in default data.`);
          return;
        }
    
        // Falls es sich um einen Image-Block handelt, URL setzen
        if (type === 'Image') {
          block.data.props.url = state.envVars.imageUrl || block.data.props.url;
        }
        
        // Hier wird die API aufgerufen, um einen leeren Block-Platzhalter in MySQL anzulegen.
        // Es werden blockId (null, da keine temporären IDs mehr genutzt werden), 
        // type (aus block.type) und data (aus block.data) übergeben.
        const response = await axios.post('https://html-creator.demo.cartago.com/api/save-block', {
          blockId: 0,
          type: block.type,
          data: block.data,
          emailId: state.emailData.id
        });
        
        // Nehmen wir an, dass die API die tatsächliche MySQL-ID als response.data.id zurückgibt
        console.log(response)
        const id = response.data.blockId;
        
        // Den Namen anhand des Block-Typs und der erhaltenen ID setzen
        block.data.props.name = `${type}${id}`;
        
        // Erstellungsdatum festlegen
        const creationDate = new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });
        
        // Den Block (nun mit der echten, konsistenten ID) im Vuex-Store speichern
        commit('addBlock', { id, creationDate, block, position, parentId, parentType, targetId, placeholderIndex });
        commit('setAdd', null);
        commit('setSharedData', { id, creationDate, ...block });
        
      } catch (error) {
        console.error('Fehler beim Speichern des Block-Platzhalters:', error);
      }
    },
    
    addNewBlockFromClipboard({ commit, state }, {position, parentId, parentType, targetId, placeholderIndex }) {
      const id = `block-${Math.floor(Math.random() * 900000000000) + 1000000000000}`;
      const creationDate = new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });
      if (state.copyClipboardHelper.id !== state.emailData.id && state.copyClipboardHelper.blocks) {
        const addSingleblock = (block) => {
          commit('addSingleBlock', block)
        }
        state.copyClipboardHelper.blocks.forEach(block => {
         addSingleblock(block)
        })
      }
      const copiedBlock = state.copyClipboard.copyType == 'copy' ? JSON.parse(JSON.stringify(state.copyClipboard)) : state.copyClipboard;
      const name = `${copiedBlock.type}${copiedBlock.id}copiedAt${creationDate}`;
      delete copiedBlock.id
      copiedBlock.data.props.name = name
        if (copiedBlock.data.props.childrenIds && copiedBlock.copyType == 'copy' && state.copyClipboardHelper.id == state.emailData.id) {
          const oldChildrenIds = copiedBlock.data.props.childrenIds;
          copiedBlock.data.props.childrenIds = deepCloneBlock(state.emailData, copiedBlock.data.props.childrenIds)
          if(copiedBlock.type == 'Ruleset') {
           copiedBlock.data.props.rules.map(rule => {
              rule.conditionalBlock = copiedBlock.data.props?.childrenIds[oldChildrenIds.indexOf(rule?.conditionalBlock)] || ''
           })
        }}
        if (copiedBlock.data.props.columns && copiedBlock.copyType == 'copy' && state.copyClipboardHelper.id == state.emailData.id) {
            copiedBlock.data.props.columns.forEach((column, index) => {
              if (column.childrenIds) {
                console.log(column)
                copiedBlock.data.props.columns[index].childrenIds = deepCloneBlock(state.emailData, column.childrenIds);  // Kinder der Spalten rekursiv kopieren
              }
            });
          }
      delete copiedBlock.copyType
      if (copiedBlock) {
        commit('addBlock', { id, creationDate, block: copiedBlock, position, parentId, parentType, targetId, placeholderIndex });
        commit('setAdd', null);
        commit('setSharedData', { id, creationDate, ...copiedBlock });
      } else {
        console.error(`Block type "${type}" not found in default data.`);
      }
    },
    async saveEmailData({ state }) {
      try {
        const response = await axios.post('https://html-creator.demo.cartago.com/email', {
          emailData: state.emailData,
          emailPath: state.exampleMail,
        });
      } catch (error) {
        console.error('Failed to save email data:', error);
      }
    },
    async removeBlock({ commit }, { parentId, parentType, blockId }) {
      try {
        await axios.delete(`https://html-creator.demo.cartago.com/api/delete-block/${blockId}`);
        commit('removeBlock', { parentId, parentType, blockId });
      } catch (error) {
        console.error('Fehler beim Löschen des Blocks:', error.message);
      }
    },
    addBoilerplate({ commit, state }, blocks) {
      const position = state.positionBoiler;
      const parentId = 'root'; 
      const parentType = 'root'; 
      const targetId = state.parentBoiler; 
      const placeholderIndex = null; 
      commit('addMultipleBlocks', { blocks, position, parentId, parentType, targetId, placeholderIndex });
      commit('setAdd', null);
      commit('setPositionBoiler', null);
      commit('setParentBoiler', null);
    },
    togglePlaceholders({ commit }, { customerId, enabled }) {
        commit('replacePlaceholderState', { enabled});
    },
    moveBlockInStore({ commit }, payload) {
      commit('MOVE_BLOCK', payload);
    },
    changePositionStyle({commit }, {id, direction}){
      commit('moveAbsoluteBlock', {id, direction});
    },
    saveMediaQueries({ commit }, mediaQueries) {
      commit('setMediaQueries', mediaQueries);
    },
    resetMediaQueries({ commit }) {
      commit('clearMediaQueries');
    },
    addClass({ commit }, className) {
      commit('ADD_CLASS', className);
    },
    
    removeClass({ commit }, className) {
      commit('REMOVE_CLASS', className);
    },
    changeTheme({ commit }, theme) {
      commit('setTheme', theme);
    },
    updateXmlFile({ commit }, file) {
      commit('setXmlFile', file);
    },
    addXmlToEmailData({ commit }, file) {
      commit('insertXml', file);
    },
    async updateXPathPlaceholders({ commit }, placeholderMapping) {
      // placeholderMapping ist ein Array von Objekten mit placeholder und xpath
      const updatedMapping = await Promise.all(
        placeholderMapping.map(async mapping => {
          // Falls ein XPath vorhanden ist, rufe asynchron getXmlValueByPath auf
          if (mapping.xpath) {
            const evaluatedValue = await getXmlValueByPath(mapping.xpath);
            return { ...mapping, value: evaluatedValue };
          }
          return mapping;
        })
      );
      commit('setXPathPlaceholders', updatedMapping);
    },
    setLocale({ commit }, locale) {
      commit('SET_LOCALE', locale);
    },
    updateTabData({ commit }, data) {
      commit('setTabData', data);
    },
    deleteTabData({ commit }, id) { 
      commit('removeTabById', id);
    },
    updateSingleTab({ commit }) {
      commit('setSingleTab');
    },
    updateCopyClipboard({ commit }, data) {
      commit('setCopyClipboard', data);
  },
    updateFolderId({commit}, id){
      commit('setFolder', id);
    },
    setUser({commit}, name){
    commit('updateUser', name);
    }
},
  getters: {
    getSharedData: (state) => state.sharedData,
    getExampleMail: (state) => state.exampleMail,
    getView: (state) => state.view,
    getActiveTab: (state) => state.activeTab,
    getAddState: (state) => state.add,
    getPositionBoiler: (state) => state.positionBoiler,
    getParentBoiler: (state) => state.parentBoiler,
    getEmailData: (state) => state.emailData,
    getPlaceholdersEnabled: (state) => state.placeholdersEnabled,
    getCustomerData: (state) => state.customerData,
    getViewport: (state) => state.viewport,
    getEmailTitle: (state) => state.emailTitle,
    getMediaQueries: (state) => state.mediaQueries,
    getCssClasses: (state) => state.cssClasses,
    getCurrentTheme: (state) => state.theme,
    getXmlFile: state => state.xmlFile,
    getXPathPlaceholders: state => state.xPathPlaceholders,
    currentLocale: state => state.locale,
    copyClipboard: state => state.copyClipboard,
    getTabData: (state) => state.tabData,
    getFolderId: (state) => state.currentFolder,
    getEnvVar: (state) => (key) => state.envVars[key]
  },
  plugins: [
    createPersistedState({
      paths: ['locale'] 
    })
  ]
});
